import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { KeyFigure, KeyFigureService } from '../services/key-figure.service';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { PostService } from '../services/post.service';
import { SlicePostsPipe } from '../slice-posts.pipe';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [RouterModule, TranslateModule, CommonModule, SlicePostsPipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent {

  baseApiUrl: string = environment.baseApiUrl;

  keyFigure: KeyFigure | null = null;
  posts: any[] = [];

  constructor(private keyFigureService: KeyFigureService, private postService: PostService, private translate: TranslateService) {}

  ngOnInit(): void {
    this.getLatestKeyFigure();

    this.getPosts(1, 10);
  }

   isKhmer(): boolean {
    return this.translate.currentLang === 'kh';
  }

  isEnglish(): boolean {
    return this.translate.currentLang === 'en';
  }


  getPosts(page: number, limit: number) {
    this.postService.getPosts(page, limit).subscribe(res => {
      this.posts = res.data.posts;
    })
  }

  getLatestKeyFigure(): void {
    this.keyFigureService.getLatestKeyFigure().subscribe(response => {
      this.keyFigure = response;
    });
  }


  ceoMessageEn = {
    title: 'Biz Operations Reforming and Internal Control System Strengthening Top Priorities, Acknowledging 2025 Outlook Will Be A Challenging Year.',
    text_1: '2024, Year of Bold Reform and Internal Control Enhancement After the impressive credit expansion that lifted the credit-to-GDP ratio from 24 % in 2010 to 135 % in 2023, the growth has come to a near halt mainly due to sluggish recovery of sectors such as construction and real estate, tourism, wholesales, and retails, and an emerging sign of debt overhang.',
    text_2: 'Considering heightened credit markets, NHFC remains cautious and strategic in lending, reforming credit operating structure, bolstering internal control system, offering targeted pricing, developing talents; thereby enhancing risk management, sharpening competitiveness, satisfying client’s evolving behavior, and accelerating staff’s capability and professionalism training and development.'
  }


  ceoMessageKh = {
    title: 'កំណែទម្រង់ប្រតិបត្តិការអាជីវកម្ម និងពង្រឹងប្រព័ន្ធគ្របគ្រង់ផ្ទៃក្នុង ជាអាទិភាព និងទទួលស្គាល់ថាឆ្នាំ២០២៥ នៅតែជាឆ្នាំប្រឈម',
    text_1: '២០២៤ គឺជាឆ្នាំកែទម្រង់ និងពង្រឹងប្រព័ន្ធគ្រប់គ្រងផ្ទៃក្នុង បន្ទាប់ពីអត្រាកំណើនឥណទានយ៉ាងខ្លាវខ្លារ ពីអនុបាតត្រឹមតែ ២៤% នៃផលិតផលដុលសរុប (ផ.ផ.ស) ក្នុងឆ្នាំ២០១០ ឡើងរហូតដល់ ១៣៥% នៃ ផ.ផ.ស ក្នុងឆ្នាំ២០២៣ កំណើនឥណទានហាក់បានដើរដល់ចំណុចទ្រឹង ដោយសារតែការងើបឡើងវិញយឺតយ៉ាវនៃវិស័យសំណង់ អចលទ្រព្យ ទេសចរណ៍ លក់ដុំ⁓លក់រាយ នេះក៏អាចជាសញ្ញា នៃកម្រិតឥណទានហួសកម្រិត។ ដោយមើលឃើញពីទីផ្សារឥណទានកាន់តែប្រកួតប្រជែងខ្លាំងឡើងៗ ណុងហឹ ហ្វាយនែន មានការប្រុងប្រយ័ត្ន និងយុទ្ធសាស្រ្ត ដោយធ្វើការកែទម្រង់រចនាសម្ព័ន្ធប្រតិបត្តិការឥណទាន បង្កើនប្រសិទ្ធិភាពនៃប្រព័ន្ធគ្រប់គ្រងផ្ទៃក្នុង បញ្ចុះអត្រាការប្រាក់តាមលក្ខខណ្ឌ និងពន្លឿនការបណ្តុះបណ្តាល និងអភិវឌ្ឍធនធានមនុស្ស សំដៅពង្រឹងការគ្រប់គ្រងហានិភ័យ ពង្រឹងភាពប្រកួតប្រជែង ឆ្លើយតបតម្រូវការនៃការវិវត្តឥរិយាបទរបស់អតិថិជន និងបង្កើនសមត្ថភាព និងវិជ្ជាជីវៈរបស់បុគ្គលិក។'
  }
  

}
